import { createLazyComponent, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(
    /* webpackChunkName: "HeaderCharms", webpackPrefetch: true */ './lazyCharms');
});
export var FeatureFlagsCharmStub = createLazyComponent(lazyModule, function (m) { return m.FeatureFlagsCharm; });
export var SkypeCharmStub = createLazyComponent(lazyModule, function (m) { return m.SkypeCharm; });
//# sourceMappingURL=charmStubs.js.map